if (!customElements.get('ace-hero-section-links')) {
  customElements.define('ace-hero-section-links', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.links = Array.from((this.closest('.ace-color-home') || this).querySelectorAll('[data-hero-section-link]'));
      this.targets = new Map(this.links.map((link) => {
        const id = link.hash.slice(1);
        let target = document.getElementById(id);
        if (!target) {
          const selector = id.startsWith('AceSpaceBrowse-') ? '.ace-category-explorer__space-heading' : id.startsWith('AceClassificationBrowse-') ? '.ace-category-explorer__classification-heading' : null;
          target = selector ? document.querySelector(selector) : null;
          if (target) {
            target.id ||= id;
            link.hash = `#${target.id}`;
          }
        }
        return [link.hash.slice(1), target];
      }).filter(([, target]) => target));
      (this.closest('.ace-color-home') || this).addEventListener('click', (event) => {
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const link = event.target.closest('[data-hero-section-link]');
        if (!link || !(this.closest('.ace-color-home') || this).contains(link) || !this.targets.has(link.hash.slice(1))) return;
        event.preventDefault();
        this.go(link.hash.slice(1), true, true);
      }, options);
      this.restore = () => {
        const id = location.hash.slice(1);
        if (this.targets.has(id)) this.go(id, false, false);
      };
      window.addEventListener('hashchange', this.restore, options);
      window.addEventListener('popstate', this.restore, options);
      window.addEventListener('load', this.restore, options);
      this.resize = () => {
        const target = this.targets.get(location.hash.slice(1));
        const wasAligned = target && Math.abs(target.getBoundingClientRect().top - (this.lastOffset || this.offset())) < 64;
        this.measure();
        if (wasAligned) this.go(target.id, false, false);
      };
      window.addEventListener('resize', this.resize, options);
      document.addEventListener('ace:announcement-resize', this.resize, options);
      this.measure();
      this.restore();
    }
    offset() {
      const header = document.querySelector('.section-header');
      const sticky = header?.classList.contains('shopify-section-header-sticky') && !header.classList.contains('shopify-section-header-hidden');
      const bar = document.querySelector('.ace-category-navigation-section');
      const bandHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--ace-sticky-announcement-height')) || 0;
      const announcement = document.querySelector('.ace-member-announcement-section');
      const bandBottom = announcement ? Math.max(0, announcement.getBoundingClientRect().bottom) : bandHeight;
      const headerBottom = sticky ? Math.max(header.getBoundingClientRect().bottom, bandHeight + header.offsetHeight) : 0;
      return Math.max(bandBottom, headerBottom) + (bar?.offsetHeight || 0) + 12;
    }
    measure() {
      this.lastOffset = this.offset();
      this.targets.forEach((target) => { target.style.scrollMarginTop = `${this.lastOffset}px`; });
    }
    go(id, record, focus) {
      const target = this.targets.get(id);
      if (!target) return;
      const version = this.jumpVersion = (this.jumpVersion || 0) + 1;
      if (record && location.hash !== `#${id}`) history.pushState(history.state, '', `#${id}`);
      const align = () => {
        if (version !== this.jumpVersion) return;
        this.measure();
        window.scrollTo({ top: Math.max(0, target.getBoundingClientRect().top + scrollY - this.lastOffset), behavior: 'instant' });
      };
      align();
      this.frame = requestAnimationFrame(() => { this.frame = requestAnimationFrame(align); });
      if (focus) {
        const temporary = !target.hasAttribute('tabindex');
        if (temporary) target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
        if (temporary) target.addEventListener('blur', () => target.removeAttribute('tabindex'), { once: true });
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      cancelAnimationFrame(this.frame);
      this.jumpVersion = (this.jumpVersion || 0) + 1;
      this.targets?.forEach((target) => { target.style.removeProperty('scroll-margin-top'); });
    }
  });
}
